<template>
  <Modal :title="title" :showModal="showModal" class="edit-order-form" @submit="submit">
    <template v-slot:body>
      <div>
        <div class="purchase-wrap">
          <label class="col-12 p-0">Purchase detail:</label>
          <div class="position-relative form-group row mt-2 mr-0 ml-0 align-items-center">
            <input class="form-control flex-1" type="text" placeholder="Price" name="purchase[price]" :value="prices.price" @change="data.purchase_detail.prices.manual.price = $event.currentTarget.value" />
            <select class="form-control col-3 ml-2" name="purchase[currency]" :value="prices.currency" @change="data.purchase_detail.prices.manual.currency = $event.currentTarget.value">
              <option v-for="(currency, index) in data.more.currency.purchase" :key="index" :value="index">
                {{ currency.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="position-relative form-group w-100 d-flex align-items-center">
          <label class="m-0">Enter package size:</label>
          <div class="togglebox-container ml-2">
            <input type="checkbox" :checked="data.use_package" @change.stop.prevent="data.use_package = Number($event.target.checked)" />
            <div class="slider"></div>
          </div>
        </div>
        <div v-if="usePackage" class="package-wrap row">
          <div class="col-12 has-tip supplier-account form-group" data-title="Account" ref="vendorAccount">
            <Select :options="vendorOptions" :group="true" placeholder="Account" v-model="data.purchase_detail.package.vendor_id" class="flex-1 mr-2"></Select>
          </div>
          <div v-show="data.purchase_detail.package.vendor_id" class="col-12 has-tip supplier-account form-group" data-title="Sku" ref="carrierSku">
            <Select :source="`vendor-account/${data.purchase_detail.package.vendor_id}/product-sku-in-vendor-account`" placeholder="Sku" :value="data.purchase_detail.package.sku" @changeValue="handlePackageSku" class="flex-1 mr-2"></Select>
          </div>
          <div class="input-group form-group col-6 pr-1">
            <div class="input-group-prepend">
              <span class="input-group-text">Length</span>
            </div>
            <input name="api_key" type="number" class="form-control" v-model="data.purchase_detail.package.length" placeholder="cm" />
          </div>
          <div class="input-group form-group col-6 pl-1">
            <div class="input-group-prepend">
              <span class="input-group-text">Width</span>
            </div>
            <input name="api_key" type="number" class="form-control" v-model="data.purchase_detail.package.width" placeholder="cm" />
          </div>
          <div class="input-group form-group col-6 pr-1">
            <div class="input-group-prepend">
              <span class="input-group-text">Height</span>
            </div>
            <input name="api_key" type="number" class="form-control" v-model="data.purchase_detail.package.height" placeholder="cm" />
          </div>
          <div class="input-group form-group col-6 pl-1">
            <div class="input-group-prepend">
              <span class="input-group-text">Weight</span>
            </div>
            <input name="api_key" type="number" class="form-control" v-model="data.purchase_detail.package.weight" placeholder="gram" />
          </div>
        </div>
        <div class="shipments-wrap">
          <label class="col-12 p-0">Shipments:</label>
          <div v-for="(shipment, index) in data.purchase_detail.shipments" :key="index" class="position-relative form-group row mt-2 mr-0 ml-0 align-items-center">
            <input class="form-control col-4 mr-2" type="text" placeholder="Carrier" name="carrier[]" v-model="shipment.carrier" />
            <input class="form-control flex-1" type="text" placeholder="Number" name="number[]" v-model="shipment.number" />
          </div>
          <div class="input-group form-group">
            <div class="input-group-prepend"><span class="input-group-text">Tracking Offset(h)</span></div>
            <input name="tracking_offset" type="number" v-model="data.tracking_offset" class="form-control flex-1" />
          </div>
        </div>
        <div class="note-wrap">
          <em>Note: Orders can only be updated once. Please make sure the information you enter is correct!</em>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      submitStructure: ['use_package', 'purchase_detail', 'tracking_offset'],
      vendorOptions: [],
      data: {
        more: {
          currency: {
            purchase: {}
          }
        },
        use_package: 0,
        tracking_offset: '',
        purchase_detail: {
          package: {
            vendor_id: '',
            sku: '',
            height: '',
            length: '',
            width: '',
            weight: ''
          },
          prices: {
            manual: {
              price: 0.1,
              currency: 'usd'
            }
          },
          shipments: {
            manual: {
              number: '',
              carrier: ''
            }
          }
        }
      }
    }
  },
  computed: {
    title() {
      return 'Edit Order'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    orderId() {
      return this.config?.data?._id
    },
    getUri() {
      return `order/get/${this.orderId}`
    },
    submitUri() {
      return `order/update-shipment/${this.orderId}`
    },
    prices() {
      return this.data.purchase_detail?.prices?.manual || {}
    },
    usePackage() {
      return this.data.use_package
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        this.data = _.mergeLeft(this.data, rawData.data)
        if (this.data.purchase_detail?.package?.sku && this.data.purchase_detail?.package?.vendor_id) {
          this.data.use_package = 1
        } else if (this.data.more.use_package) {
          this.data.use_package = this.data.more.use_package
        } else {
          this.data.use_package = 0
        }
        if (!this.data?.purchase_detail?.prices?.manual?.currency) {
          this.data.purchase_detail.prices.manual.currency = 'usd'
        }
        if (this.$util.cookie.get('edit-shipment.vendor-id')) {
          this.data.purchase_detail.package.vendor_id = this.$util.cookie.get('edit-shipment.vendor-id')
        }
      }
    },
    changeFlag(e) {
      this.data.flag = e.currentTarget.value
    },
    indexVendorId() {
      if (this.data.use_package) {
        this.$util.forceGet('vendor-account', {}, this.$refs.vendorAccount, {
          done: (response) => {
            if (response.status == 'success') {
              this.vendorOptions = Object.values(response.items)
              if (!this.data.purchase_detail.package.vendor_id && this.$util.getObjectVal(this.vendorOptions, '0.children.0.id') != null) {
                this.data.purchase_detail.package.vendor_id = this.vendorOptions[0].children[0].id
              }
            } else {
              console.log(response)
            }
          }
        })
      } else {
        this.vendorOptions = []
      }
    },
    handlePackageSku(value, args) {
      if (this.data.purchase_detail?.package?.sku != value) {
        this.data.purchase_detail.package.sku = value
        this.data.purchase_detail.package.height = args.selected.height || 0
        this.data.purchase_detail.package.length = args.selected.length || 0
        this.data.purchase_detail.package.width = args.selected.width || 0
        this.data.purchase_detail.package.weight = args.selected.weight || 0
      }
    },
    submit() {
      this.submitForm(this.data, {
        done: () => {
          this.$emit('close')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  watch: {
    'usePackage'(value) {
      if (value) this.indexVendorId()
    },
    'data.purchase_detail.package.vendor_id'(value) {
      this.$util.cookie.set('edit-shipment.vendor-id', value)
    }
  },
  props: {
    config: Object
  }
}
</script>
